import React from 'react';
import styled from 'styled-components';
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import { Link } from 'react-router-dom';

import FadeInImg from '../FadeInImg';
import breakpoints from '../../util/breakpoints';

const Wrapper = styled.div`
  margin-top: 30px;

  ${breakpoints.md`
    margin-top: 50px;
  `}
`;

const RowLink = styled(Link)`
  color: black;

  &:hover {
    text-decoration: none;
    color: black;

    span.view::before {
      width: 100%;
    }
  }

  span.view {
    position: relative;
    float: left;
    display: block;
    margin-top: 35px;
    padding: 7px 0 5px;
    text-transform: uppercase;
    font-size: 0.7em;
    font-weight: 700;
    letter-spacing: 0.2em;
    border-bottom: 2px solid black;
    color: black;
    z-index: 1;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      background-color: #89e7c6;
      width: 0;
      height: 100%;
      display: block;
      z-index: -1;

      transition: width 0.5s ease-out;
    }
  }
`;

const H1 = styled.h1`
  color: white;
  font-weight: 700;
  text-align: center;
`;

const ProjectRow = styled(Row)`
  position: relative;
  top: 0;
  left: 0;
  margin: 30px 0 60px 0;
  filter: brightness(100%);

  transition: all 0.3s;

  ${breakpoints.md`
    margin: 70px 0 0 0;
    filter: brightness(85%);
  `}

  &:hover {
    top: -3px;
    filter: brightness(100%);
  }
`;

const ImageCol = styled(Col)`
  padding: 0;
  min-height: 300px;
  background: #111323;

  ${breakpoints.lg`
    min-height: 500px;
  `}
`;

const DescriptionCol = styled(Col)`
  background-color: white;
  min-height: 300px;
  padding: 50px;

  ${breakpoints.sm`
    padding: 75px;
    min-height: 500px;
  `}

  ${breakpoints.lg`
    padding: 100px 100px 80px;
    min-height: 500px;
  `}

  h2 {
    font-size: 1.2em;
    font-weight: 700;
    color: #777;
  }

  p {
    font-size: 1.4em;
    color: black;
    font-weight: 700;
    padding-top: 10px;

    ${breakpoints.md`
      font-size: 1.8em;
    `}
  }

  ul {
    float: left;
    text-transform: uppercase;
    margin: 0;
    padding: 0;
    margin-top: 25px;
  }

  li {
    float: left;
    list-style: none;
    font-size: 0.7em;
    font-weight: 700;
    padding: 5px 25px 0 0;
    letter-spacing: 0.2em;
  }
`;

const WorkHero = () => (
  <Wrapper>
    <Container>

      <Row>
        <Col>
          <H1>our work</H1>
        </Col>
      </Row>

      <RowLink to="/work/wwworldcup">
        <ProjectRow>
          <ImageCol sm="12" lg="5">
            <FadeInImg src="/images/work/wwworldcup/work-hero.jpg" />
          </ImageCol>
          <DescriptionCol sm="12" lg="7">
            <h2>WWWorld Cup</h2>
            <p>an online trading card game, for FIFA's 2018 World Cup, as a social experiment on the Ethereum web3 blockchain.</p>
            <ul>
              <li>ui / ux</li>
              <li>blockchain</li>
              <li>ipfs</li>
              <li>illustration</li>
              <li>solidity</li>
              <li>ethereum</li>
            </ul>
            <span className="view">view project</span>
          </DescriptionCol>
        </ProjectRow>
      </RowLink>

      <RowLink to="/work/lacuna">
        <ProjectRow>
          <ImageCol sm="12" lg="5">
            <FadeInImg src="/images/work/lacuna/work-hero.jpg" />
          </ImageCol>
          <DescriptionCol sm="12" lg="7">
            <h2>Lacuna</h2>
            <p>an upcoming Las Vegas farm to table restaurant, website showcasing full rebrand</p>
            <ul>
              <li>website design</li>
              <li>ui / ux</li>
              <li>content strategy</li>
              <li>art direction</li>
            </ul>
            <span className="view">view project</span>
          </DescriptionCol>
        </ProjectRow>
      </RowLink>

      <RowLink to="/work/gloo">
        <ProjectRow>
          <ImageCol sm="12" lg="5">
            <FadeInImg src="/images/work/gloo/row1.jpg" />
          </ImageCol>
          <DescriptionCol sm="12" lg="7">
            <h2>Gloo</h2>
            <p>a mentorship platform for growth and human development, marketing and design direction</p>
            <ul>
              <li>ui / ux</li>
              <li>hubspot</li>
              <li>illustration</li>
              <li>marketing</li>
              <li>component design</li>
            </ul>
            <span className="view">view project</span>
          </DescriptionCol>
        </ProjectRow>
      </RowLink>

    </Container>

  </Wrapper>
);

export default WorkHero;



// WEBPACK FOOTER //
// ./src/components/ui/WorkHero.js